import IndexLayout from '@/pages/web/layout'

//首页
import Index from '@/pages/web/index'
//业务介绍
import Intro from '@/pages/web/intro'
//关于我们
import AboutUs from '@/pages/web/aboutus'
//联系我们
import Contact from '@/pages/web/contact'
//合作伙伴
import Partner from '@/pages/web/partner'
//登录
import Login from '@/pages/web/login'
//忘记密码
import ForgetPassword from '@/pages/web/forget.password/index.vue'
//注册账户
import Register from '@/pages/web/register/index.vue'
//充值成功
import ChargeCallback from '@/pages/web/chargecallback'


export default [{
  path: '/',
  component: IndexLayout,
  redirect: '/Index',
  children: [{
    path: '/Index',
    component: Index,
    meta: {
      title: '蜂巢海外仓'
    },
  }, {
    path: '/Intro',
    component: Intro,
  }, {
    path: '/AboutUs',
    component: AboutUs,
  }, {
    path: '/Contact',
    component: Contact,
  }, {
    path: '/Partner',
    component: Partner,
  }, {
    path: '/Login',
    component: Login,
  }, {
    path: '/Register',
    component: Register
  }, {
    path: '/ForgetPassword',
    component: ForgetPassword
  }, {
    path: '/ChargeCallback',
    component: ChargeCallback
  }]
}]



// WEBPACK FOOTER //
// ./src/router/module/web.js